// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WPSvLW,
.led3RR {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-base);
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: var(--spacing-3);
  padding: var(--spacing-4);
}

.NdbIi4 {
  background: #fff0e5;
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.uIeNMV {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  max-width: 350px;
  text-align: center;
}

.tnDTp9 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
  margin: 0;
}

.t1JtaU {
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-160);
  margin: 0;
}

.SX_TGN {
  font-size: var(--type-subtitle-md-font-size);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-2, 16px);
}

.P4bYjb {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
}

.GXcLLy {
  display: flex;
  align-items: flex-end;
  gap: var(--spacing-3, 24px);
  flex-wrap: wrap;
}

.RFPBCP {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  flex: 1;
  min-width: 200px;
}

.Vhspbm {
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-medium, 500);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1, 8px);
}

.NYylN2 {
  display: flex;
  gap: var(--spacing-1, 8px);
  align-items: center;
}

.jLbj7t {
  padding: var(--spacing-1-5, 12px);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  background-color: var(--surface-neutral-pale, #fafafa);
  font-size: var(--font-size-md, 14px);
  color: var(--primary-orange-500, #d64000);
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 80px;
}

.jLbj7t:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
}

.jLbj7t:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.BT1Oxt {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  min-width: 120px;
  max-width: calc(50% - 12px);
  width: calc(50% - 12px);
}

.TJ1gW3 {
  display: flex;
  align-items: flex-end;
  min-width: 120px;
}

.x2Wn_o {
  white-space: nowrap;
  font-size: var(--font-size-lg, 16px);
  margin-bottom: 5px;
}

.Sy9Qo1 {
  background-color: var(--surface-neutral-pale, #fafafa);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  display: flex;
  gap: var(--spacing-1-5);
  width: 100%;
}

.JGsK3C {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.DVNKgP {
  padding: var(--spacing-1-5);
  padding-right: 20px;
  border: none;
  background: transparent;
  font-size: var(--font-size-md, 14px);
  color: var(--primary-orange-500, #d64000);
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.WxqP3K {
  position: absolute;
  right: 0;
  pointer-events: none;
  color: var(--primary-orange-500, #d64000);
  width: var(--spacing-2, 16px);
  height: var(--spacing-2, 16px);
}

.DVNKgP:focus {
  outline: none;
}

.fgQWDs {
  width: 1px;
  height: 24px;
  background-color: var(--stroke-neutral-silver, #cccccc);
  margin: var(--spacing-1-5) 0;
}

._LwTAm {
  flex: 1;
}

.ITzSSv {
  border: none;
}

.LU4uvR {
  flex: 1;
  font-weight: var(--font-weight-semibold);
  min-height: var(--spacing-6);
  padding-right: var(--spacing-1-5, 12px);
  color: var(--text-neutral-dark);
  background-color: transparent;
  border: none;
  text-align: right;
  outline: 0;
}

.NYudgL {
  display: flex;
  align-items: center;
  gap: var(--spacing-2, 16px);
  background-color: var(--surface-neutral-pale, #fafafa);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
}

.Iz7zyM {
  flex: 1;
  max-width: 120px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: left;
  border: none;
}

.i1fusu {
  border: none !important;
}

.aBJHy7 {
  white-space: nowrap;
  min-width: 115px;
}

.wSTRdP {
  display: flex;
  align-items: center;
  min-width: 120px;
}

.N9WPLP {
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: center;
  background-color: transparent;
  border: none;
  min-height: var(--spacing-6);
  padding: var(--spacing-1-5, 12px);
}

.IEGplU {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.tcB2hG {
  white-space: nowrap;
  min-width: 80px;
  font-size: var(--font-size-sm, 12px);
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
}

.Bpn810 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5, 12px);
  background-color: var(--surface-neutral-pale, #fafafa);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  padding: var(--spacing-1-5, 12px);
  width: 100%;
}

.fD7KdK {
  flex: 1;
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: center;
  min-height: var(--spacing-6);
  background-color: transparent;
  border: none;
  outline: none;
  max-width: 120px;
}

.Mbvdqv {
  white-space: nowrap;
  min-width: 120px;
  font-size: var(--font-size-sm, 12px);
}

.rU3hMT {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.tpfAHL {
  white-space: nowrap;
}

.z2ERYF {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  flex: 1;
}

.HwICJ9 {
  margin: 0;
  color: var(--text-neutral-dark, #1f1f1f);
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: 14px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.8;
}

._4965W {
  display: flex;
  align-items: center;
  min-height: 49px;
  gap: var(--spacing-2);
  padding: var(--spacing-1) var(--spacing-2);
  font-family: var(--font-family-base);
}

.gVnJmE {
  align-items: center;
  display: flex;
  gap: var(--spacing-2);
  flex: 1;
}

.DMVyJH,
.iqz2uh,
.MmvaiL,
.gmIAzV,
.Vvvk5B,
.rp2fwk,
.AqeNRY,
.sCiJ93 {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  line-height: var(--line-height-180);
}

.DMVyJH {
  flex: 1;
  min-width: 210px;
}

.iqz2uh,
.MmvaiL,
.gmIAzV,
.Vvvk5B,
.rp2fwk,
.AqeNRY,
.sCiJ93 {
  flex-shrink: 0;
}

.iqz2uh,
.gmIAzV,
.Vvvk5B,
.rp2fwk,
.AqeNRY,
.sCiJ93 {
  width: var(--spacing-15);
}

.MmvaiL {
  width: 80px;
}

.rp2fwk {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.FUgQSP {
  display: flex;
  flex-direction: column;
  max-height: 400px;
}

.FUgQSP::-webkit-scrollbar {
  width: 6px;
}

.FUgQSP::-webkit-scrollbar-track {
  background: var(--surface-neutral-pale);
  border-radius: 3px;
}

.FUgQSP::-webkit-scrollbar-thumb {
  background: var(--stroke-neutral-silver);
  border-radius: 3px;
}

.FUgQSP::-webkit-scrollbar-thumb:hover {
  background: var(--text-neutral-medium);
}

@media (max-width: 768px) {
  .Sy9Qo1 {
    flex-direction: column;
    gap: 0;
  }

  .fgQWDs {
    width: 100%;
    height: 1px;
    margin: 0;
  }

  .NYudgL {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-1-5, 12px);
  }

  .Iz7zyM {
    max-width: none;
  }

  .Bpn810 {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-1-5, 12px);
  }

  .fD7KdK {
    max-width: none;
    text-align: left;
  }

  ._4965W {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-2, 16px);
    padding-left: 0;
  }

  ._cswpp {
    width: 100%;
    max-width: none;
  }
}

.DVNKgP:focus-visible,
.DR7mKd:focus-visible,
.Iz7zyM:focus-visible,
.fD7KdK:focus-visible {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
}

.DVNKgP:disabled,
.DR7mKd:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.aBJHy7:disabled,
.tpfAHL:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryValuesForm/BeneficiaryValuesForm.module.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,uDAAuD;EACvD,mCAAmC;EACnC,sDAAsD;EACtD,oCAAoC;EACpC,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;EACtD,uDAAuD;EACvD,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,yCAAyC;EACzC,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,wCAAwC;EACxC,4BAA4B;EAC5B,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sDAAsD;EACtD,uDAAuD;EACvD,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sDAAsD;EACtD,uDAAuD;EACvD,mCAAmC;EACnC,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,OAAO;EACP,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,iEAAiE;EACjE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,OAAO;AACT;;AAEA;;;;;;;;EAQE,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,WAAW;IACX,WAAW;IACX,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;;;;EAIE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".loadingContainer,\n.noResultsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-family-base);\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  gap: var(--spacing-3);\n  padding: var(--spacing-4);\n}\n\n.loadingIcon {\n  background: #fff0e5;\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.noResultsContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  max-width: 350px;\n  text-align: center;\n}\n\n.noResultsTitle {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n  margin: 0;\n}\n\n.noResultsDescription {\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-160);\n  margin: 0;\n}\n\n.sectionTitle {\n  font-size: var(--type-subtitle-md-font-size);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-2, 16px);\n}\n\n.releaseConfigContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n}\n\n.formFieldsRow {\n  display: flex;\n  align-items: flex-end;\n  gap: var(--spacing-3, 24px);\n  flex-wrap: wrap;\n}\n\n.valueSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  flex: 1;\n  min-width: 200px;\n}\n\n.fieldLabel {\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-medium, 500);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1, 8px);\n}\n\n.valueInputsGroup {\n  display: flex;\n  gap: var(--spacing-1, 8px);\n  align-items: center;\n}\n\n.releaseTypeSelect {\n  padding: var(--spacing-1-5, 12px);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  background-color: var(--surface-neutral-pale, #fafafa);\n  font-size: var(--font-size-md, 14px);\n  color: var(--primary-orange-500, #d64000);\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  min-width: 80px;\n}\n\n.releaseTypeSelect:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n}\n\n.releaseTypeSelect:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.businessDaysSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  min-width: 120px;\n  max-width: calc(50% - 12px);\n  width: calc(50% - 12px);\n}\n\n.applyButtonSection {\n  display: flex;\n  align-items: flex-end;\n  min-width: 120px;\n}\n\n.applyButton {\n  white-space: nowrap;\n  font-size: var(--font-size-lg, 16px);\n  margin-bottom: 5px;\n}\n\n.releaseTypeAndValueContainer {\n  background-color: var(--surface-neutral-pale, #fafafa);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  display: flex;\n  gap: var(--spacing-1-5);\n  width: 100%;\n}\n\n.dropdownContainer {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.releaseTypeDropdown {\n  padding: var(--spacing-1-5);\n  padding-right: 20px;\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-md, 14px);\n  color: var(--primary-orange-500, #d64000);\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.dropdownIcon {\n  position: absolute;\n  right: 0;\n  pointer-events: none;\n  color: var(--primary-orange-500, #d64000);\n  width: var(--spacing-2, 16px);\n  height: var(--spacing-2, 16px);\n}\n\n.releaseTypeDropdown:focus {\n  outline: none;\n}\n\n.divider {\n  width: 1px;\n  height: 24px;\n  background-color: var(--stroke-neutral-silver, #cccccc);\n  margin: var(--spacing-1-5) 0;\n}\n\n.valueContainer {\n  flex: 1;\n}\n\n.valueInputContainer {\n  border: none;\n}\n\n.valueInput {\n  flex: 1;\n  font-weight: var(--font-weight-semibold);\n  min-height: var(--spacing-6);\n  padding-right: var(--spacing-1-5, 12px);\n  color: var(--text-neutral-dark);\n  background-color: transparent;\n  border: none;\n  text-align: right;\n  outline: 0;\n}\n\n.businessDaysContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2, 16px);\n  background-color: var(--surface-neutral-pale, #fafafa);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n}\n\n.businessDaysInput {\n  flex: 1;\n  max-width: 120px;\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: left;\n  border: none;\n}\n\n.businessDaysInputContainer {\n  border: none !important;\n}\n\n.applyBusinessDaysButton {\n  white-space: nowrap;\n  min-width: 115px;\n}\n\n.businessDaysInlineContainer {\n  display: flex;\n  align-items: center;\n  min-width: 120px;\n}\n\n.businessDaysInlineInput {\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: center;\n  background-color: transparent;\n  border: none;\n  min-height: var(--spacing-6);\n  padding: var(--spacing-1-5, 12px);\n}\n\n.applyButtonInlineContainer {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.applyBusinessDaysInlineButton {\n  white-space: nowrap;\n  min-width: 80px;\n  font-size: var(--font-size-sm, 12px);\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n}\n\n.businessDaysRowContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5, 12px);\n  background-color: var(--surface-neutral-pale, #fafafa);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  padding: var(--spacing-1-5, 12px);\n  width: 100%;\n}\n\n.businessDaysRowInput {\n  flex: 1;\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: center;\n  min-height: var(--spacing-6);\n  background-color: transparent;\n  border: none;\n  outline: none;\n  max-width: 120px;\n}\n\n.applyBusinessDaysRowButton {\n  white-space: nowrap;\n  min-width: 120px;\n  font-size: var(--font-size-sm, 12px);\n}\n\n.monthlyValueContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.monthlyApplyValueButton {\n  white-space: nowrap;\n}\n\n.formSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  flex: 1;\n}\n\n.infoText {\n  margin: 0;\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: 14px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 1.8;\n}\n\n.beneficiariesHeader {\n  display: flex;\n  align-items: center;\n  min-height: 49px;\n  gap: var(--spacing-2);\n  padding: var(--spacing-1) var(--spacing-2);\n  font-family: var(--font-family-base);\n}\n\n.beneficiariesHeaderContent {\n  align-items: center;\n  display: flex;\n  gap: var(--spacing-2);\n  flex: 1;\n}\n\n.beneficiariesHeaderLabel,\n.beneficiariesHeaderType,\n.beneficiariesHeaderCard,\n.beneficiariesHeaderDays,\n.beneficiariesHeaderTotal,\n.beneficiariesHeaderDiscount,\n.beneficiariesHeaderStatus,\n.beneficiariesHeaderActions {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-180);\n}\n\n.beneficiariesHeaderLabel {\n  flex: 1;\n  min-width: 210px;\n}\n\n.beneficiariesHeaderType,\n.beneficiariesHeaderCard,\n.beneficiariesHeaderDays,\n.beneficiariesHeaderTotal,\n.beneficiariesHeaderDiscount,\n.beneficiariesHeaderStatus,\n.beneficiariesHeaderActions {\n  flex-shrink: 0;\n}\n\n.beneficiariesHeaderType,\n.beneficiariesHeaderDays,\n.beneficiariesHeaderTotal,\n.beneficiariesHeaderDiscount,\n.beneficiariesHeaderStatus,\n.beneficiariesHeaderActions {\n  width: var(--spacing-15);\n}\n\n.beneficiariesHeaderCard {\n  width: 80px;\n}\n\n.beneficiariesHeaderDiscount {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.beneficiariesList {\n  display: flex;\n  flex-direction: column;\n  max-height: 400px;\n}\n\n.beneficiariesList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.beneficiariesList::-webkit-scrollbar-track {\n  background: var(--surface-neutral-pale);\n  border-radius: 3px;\n}\n\n.beneficiariesList::-webkit-scrollbar-thumb {\n  background: var(--stroke-neutral-silver);\n  border-radius: 3px;\n}\n\n.beneficiariesList::-webkit-scrollbar-thumb:hover {\n  background: var(--text-neutral-medium);\n}\n\n@media (max-width: 768px) {\n  .releaseTypeAndValueContainer {\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .divider {\n    width: 100%;\n    height: 1px;\n    margin: 0;\n  }\n\n  .businessDaysContainer {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-1-5, 12px);\n  }\n\n  .businessDaysInput {\n    max-width: none;\n  }\n\n  .businessDaysRowContainer {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-1-5, 12px);\n  }\n\n  .businessDaysRowInput {\n    max-width: none;\n    text-align: left;\n  }\n\n  .beneficiariesHeader {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-2, 16px);\n    padding-left: 0;\n  }\n\n  .searchContainer {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n.releaseTypeDropdown:focus-visible,\n.searchInput:focus-visible,\n.businessDaysInput:focus-visible,\n.businessDaysRowInput:focus-visible {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n}\n\n.releaseTypeDropdown:disabled,\n.searchInput:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.applyBusinessDaysButton:disabled,\n.monthlyApplyValueButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `WPSvLW`,
	"noResultsContainer": `led3RR`,
	"loadingIcon": `NdbIi4`,
	"noResultsContent": `uIeNMV`,
	"noResultsTitle": `tnDTp9`,
	"noResultsDescription": `t1JtaU`,
	"sectionTitle": `SX_TGN`,
	"releaseConfigContainer": `P4bYjb`,
	"formFieldsRow": `GXcLLy`,
	"valueSection": `RFPBCP`,
	"fieldLabel": `Vhspbm`,
	"valueInputsGroup": `NYylN2`,
	"releaseTypeSelect": `jLbj7t`,
	"businessDaysSection": `BT1Oxt`,
	"applyButtonSection": `TJ1gW3`,
	"applyButton": `x2Wn_o`,
	"releaseTypeAndValueContainer": `Sy9Qo1`,
	"dropdownContainer": `JGsK3C`,
	"releaseTypeDropdown": `DVNKgP`,
	"dropdownIcon": `WxqP3K`,
	"divider": `fgQWDs`,
	"valueContainer": `_LwTAm`,
	"valueInputContainer": `ITzSSv`,
	"valueInput": `LU4uvR`,
	"businessDaysContainer": `NYudgL`,
	"businessDaysInput": `Iz7zyM`,
	"businessDaysInputContainer": `i1fusu`,
	"applyBusinessDaysButton": `aBJHy7`,
	"businessDaysInlineContainer": `wSTRdP`,
	"businessDaysInlineInput": `N9WPLP`,
	"applyButtonInlineContainer": `IEGplU`,
	"applyBusinessDaysInlineButton": `tcB2hG`,
	"businessDaysRowContainer": `Bpn810`,
	"businessDaysRowInput": `fD7KdK`,
	"applyBusinessDaysRowButton": `Mbvdqv`,
	"monthlyValueContainer": `rU3hMT`,
	"monthlyApplyValueButton": `tpfAHL`,
	"formSection": `z2ERYF`,
	"infoText": `HwICJ9`,
	"beneficiariesHeader": `_4965W`,
	"beneficiariesHeaderContent": `gVnJmE`,
	"beneficiariesHeaderLabel": `DMVyJH`,
	"beneficiariesHeaderType": `iqz2uh`,
	"beneficiariesHeaderCard": `MmvaiL`,
	"beneficiariesHeaderDays": `gmIAzV`,
	"beneficiariesHeaderTotal": `Vvvk5B`,
	"beneficiariesHeaderDiscount": `rp2fwk`,
	"beneficiariesHeaderStatus": `AqeNRY`,
	"beneficiariesHeaderActions": `sCiJ93`,
	"beneficiariesList": `FUgQSP`,
	"searchContainer": `_cswpp`,
	"searchInput": `DR7mKd`
};
module.exports = ___CSS_LOADER_EXPORT___;
